import '../../sassStyles/modals.scss'
import { useTheme } from '../../contexts/ThemeContext';

export function Modal(props) {
    const { theme } = useTheme();

    const handleClick = () => {
        props.setShow(false);
    }


    if (props.show)
        return (
            <div className={`${theme}-overlay`} onClick={handleClick}>
                <div className='modal-content-container' onClick={e => {
                    // do not close modal if anything inside modal content is clicked
                    e.stopPropagation();
                }}>
                    <div className='modal-header'>
                        <div className='close-button'>
                            <button type="button" onClick={handleClick}>X</button>
                        </div>
                        <div className='title'>
                            <p>{props.title}</p>
                        </div>

                    </div>
                    <div className='modal-body'>
                        {props.content}
                    </div>
                    <div className='modal-footer'></div>
                </div>
            </div>
        );
}